import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/**
 * 네이티브 상태바 초기화.
 * overlaysWebView(true) + AppTopBar의 env(safe-area-inset-top) 패딩 조합으로
 * 상태바 아래 영역까지 앱이 그리되 콘텐츠는 침범하지 않게 한다.
 */
export function useStatusBar() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    StatusBar.setStyle({ style: Style.Light }).catch(() => {});
    if (Capacitor.getPlatform() === 'android') {
      StatusBar.setOverlaysWebView({ overlay: true }).catch(() => {});
    }
  }, []);
}
